// utils.js
import { REACT_APP_ROUTE_HOME } from '../../components/common/Routes/URLs';
/**
 * Redirige al usuario según el estado de la agencia y la organización.
 * @param {Object} agency - Objeto con información de la agencia.
 * @param {Function} navigate - Función navigate de react-router-dom v6.
 */
export const redirectOnLogin = (agency, navigate) => {
  const lang = window.location.pathname.split('/')[2];

  if (agency.status === 'A' && agency.organizationEntity?.status === 'A') {
    navigate(`/protected/${lang}`);
  } else if (agency.status === 'P' && agency.organizationEntity?.status === 'A') {
    navigate(`/pending/user/${lang}`);
  } else if (agency.status === 'P' && agency.organizationEntity?.status === 'P') {
    navigate(`/pending/agency/${lang}`);
  } else if (agency.status === 'D' && agency.organizationEntity?.status === 'A') {
    navigate(`/denied/user/${lang}`);
  } else if (agency.status === 'D' && agency.organizationEntity?.status === 'D') {
    navigate(`/denied/agency/${lang}`);
  } else if (agency.status === 'ERROR') {
    navigate(`/error/${lang}`);
  } else {
    navigate(REACT_APP_ROUTE_HOME(lang));
  }
};

/**
 * Encuentra el índice del primer elemento que cumple la condición.
 * @param {Array} arr - Array de objetos.
 * @param {any} id - Valor a buscar.
 * @param {string} fieldName - Nombre del campo por el que se compara.
 * @returns {number} - Índice del elemento encontrado, o -1 si no existe.
 */
export const findByProp = (arr, id, fieldName) => {
  return arr.findIndex((x) => x[fieldName] === id);
};

/**
 * Encuentra todos los elementos que cumplen la condición.
 * @param {Array} arr - Array de objetos.
 * @param {any} id - Valor a buscar.
 * @param {string} fieldName - Nombre del campo por el que se compara.
 * @returns {Array} - Array de objetos que cumplen la condición.
 */
export const findAllByProp = (arr, id, fieldName) => {
  return arr.filter((x) => x[fieldName] === id);
};

/**
 * Construye las iniciales de un usuario a partir de su nombre y apellido.
 * @param {string} firstName - Nombre.
 * @param {string} lastName - Apellido.
 * @returns {string} - Iniciales en mayúscula (ej. "JD").
 */
export const getInitials = (firstName, lastName) => {
  return [firstName, lastName]
    .filter(Boolean)
    .map((name) => name[0])
    .join('')
    .toUpperCase();
};
